import { PaginatedApiRequestQueryArgs } from "api/rest/types/requests";
import { ApiResponsePaginatedCursor } from "api/rest/types/responses";
import { Mode } from "types/Mode";
import enhanceWithPagination from "utils/enhanceWithPagination";

import { baseRestApi } from "../../baseRestApi";
import { BrokerContractType } from "../brokerBidContractApi/types/BrokerContractType";

module.hot?.accept();

type BrokerGetContractsApiArgs = PaginatedApiRequestQueryArgs<{
  queryParams: {
    mode?: Mode;
    search?: string;
  };
}>;

const brokerGetContractsApi = baseRestApi.enhanceEndpoints({ addTagTypes: ["BrokerContracts"] }).injectEndpoints({
  overrideExisting: module.hot?.status() === "apply",
  endpoints: (builder) => ({
    brokerGetContractsApi: builder.query<
      ApiResponsePaginatedCursor<{ contracts: BrokerContractType[] }>,
      BrokerGetContractsApiArgs
    >({
      query: (args) => ({ url: `broker/contracts`, method: "GET", params: args.queryParams }),
      providesTags: ["BrokerContracts"],
    }),
  }),
});

export default brokerGetContractsApi;
export const { useBrokerGetContractsApiQuery } = enhanceWithPagination(brokerGetContractsApi, "brokerGetContractsApi");
